import React from 'react';
import { Card, CardContent, Typography, Box, LinearProgress, Grid, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ExposureStatsCardProps {
  profilesExposed: number;
  brokersScanned: number;
}

const ExposureStatsCard: React.FC<ExposureStatsCardProps> = ({
  profilesExposed = 179,
  brokersScanned = 358,
}) => {
  const progress = (profilesExposed / brokersScanned) * 100;

  return (
    <Card
      sx={{
        borderRadius: '16px',
        boxShadow: '0px 4px 10px rgba(208, 210, 218, 0.37)',
        height: 261,
        minWidth: 320,
        background: '#FFFFFF'
        ,
      }}
    >
      <CardContent >
        {/* Header */}
        <Box display="flex" alignItems="center" gap={2.5} sx={{mb: 7, mt:1.5}}>
          <Typography
            sx={{ fontFamily: 'InterSemiBold', fontSize: 18, fontWeight: 600, color: '#1A1B20'}}
          >
            Exposure Stats
          </Typography>
          <Tooltip
            title="This section shows how many data brokers were scanned and how many of your exposed profiles were found across them"
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  fontFamily: 'InterRegular',
                  fontSize: '10px',
                  lineHeight: '16px',
                  fontWeight: 500,
                  color: '#ffffff',
                }
              },
            }}
          >
            <InfoOutlinedIcon
              sx={{
                fontSize: 18,
                color: '#D0D1D2',
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        
        </Box>
        <Box display={'flex'} gap={3} alignItems={'center'} pb={4}>
            {/* Main number */}
            <Typography
                sx={{
                    fontFamily: 'InterRegular',
                    fontSize: 26,
                    fontWeight: 600,
                    color: '#11263C',
                }}
                >
                {profilesExposed}
            </Typography>
            <Typography
                sx={{
                    fontFamily: 'InterRegular',
                    fontSize: 17,
                    color: '#000000',
                    fontWeight: 600,
                    lineHeight:'22px',
                }}
                >
                Exposed Profiles
            </Typography>
        </Box>
        {/* Progress Bar */}
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 19,
            borderRadius: 5,
            width: {xs: 300, sm: 330, md: 300, lg: 310},
            mb: 3,
            backgroundColor: '#E3DEF7 !important',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#7459D9',
              borderRadius: 5,
            },
          }}
        />

        {/* Bottom stats */}
        <Box
        display="flex"
        alignItems="center"
        sx={{ mt: 8, gap: {sm: 4, md: 12} }}
        >
        {/* Left Column */}
        <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%">
            <Grid container gap={2} alignItems="flex-start">
                <Grid item xs="auto">
                    <Box
                        sx={{
                        width: 20,
                        height: 4,
                        mt:2,
                        borderRadius: 3,
                        backgroundColor: '#7459D9',
                        }}
                    />
                </Grid>

                <Grid item xs p={0}>
                    <Typography
                        sx={{
                        fontFamily: 'InterRegular',
                        fontSize: 14,
                        color: '#7459D9',
                        fontWeight: 600
                        }}
                    >
                        Profile Exposed
                    </Typography>
                    <Typography
                        sx={{
                        fontFamily: 'InterSemiBold',
                        fontSize: 18,
                        color: '#11263C',
                        mt: 0.5,
                        }}
                    >
                        {profilesExposed}
                    </Typography>
                </Grid>
            </Grid>
            </Box>

        {/* Right Column */}
        <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%">
            <Grid container gap={2} alignItems="flex-start">
                <Grid item xs="auto">
                    <Box
                        sx={{
                        width: 20,
                        height: 4,
                        mt: 2,
                        borderRadius: 3,
                        backgroundColor: '#7459D980',
                        }}
                    />
                </Grid>

                <Grid item xs>
                    <Typography
                        sx={{
                        fontFamily: 'InterRegular',
                        fontSize: 14,
                        color: '#7459D9',
                        fontWeight: 600
                        }}
                    >
                        Brokers Scanned
                    </Typography>
                    <Typography
                        sx={{
                        fontFamily: 'InterSemiBold',
                        fontSize: 18,
                        color: '#11263C',
                        mt: 0.5,
                        }}
                    >
                        {brokersScanned}
                    </Typography>
                </Grid>
            </Grid>
            </Box>

        </Box>
      </CardContent>
    </Card>
  );
};

export default ExposureStatsCard;
